import { storiesOf } from '@storybook/react';
import React, { useEffect } from 'react';
import Frame, { FrameContextConsumer } from 'react-frame-component';
import WixDesignSystemProvider from '../../../WixDesignSystemProvider';

const CustomIframe = ({ children }: { children: React.ReactNode }) => {
  const [bodyClassName, setBodyClassName] = React.useState(
    document.body.className,
  );

  // copy everything in the outer document's head into the inner document to set the styles
  // https://github.com/ryanseddon/react-frame-component/issues/37#issuecomment-215271946
  const initialContent = `<!DOCTYPE html><html><head>${document.head.innerHTML}</head><body><div></div></body></html>`;

  useEffect(() => {
    setTimeout(() => {
      // because WDS provider classes are immediately available
      setBodyClassName(document.body.className);
    }, 100);
  }, []);

  return (
    <Frame width={480} height={1200} initialContent={initialContent}>
      <FrameContextConsumer>
        {({ document }) => {
          if (document) {
            document.body.className = bodyClassName;
          }

          return children;
        }}
      </FrameContextConsumer>
    </Frame>
  );
};

export const addStories = ({
  title,
  describe,
  it,
  render,
  isMobile,
}: {
  title: string;
  describe?: string;
  it: string;
  render: () => React.ReactElement;
  isMobile: boolean;
}) => {
  const story = storiesOf(`${title}${describe ? '/' + describe : ''}`, module);

  story.add(it, () => render());

  if (isMobile) {
    story.add(`${it}-screen-small`, () => (
      <>
        <CustomIframe>{render()}</CustomIframe>
        <CustomIframe>
          <WixDesignSystemProvider mobile>{render()}</WixDesignSystemProvider>
        </CustomIframe>
      </>
    ));
  }
};
